module.exports = __webpack_public_path__ + "common/gh-question-icon-246437cef1f165e51ee068239a789146.svg";